<div class="row waitlist-section">
  <div class="col-md-1 col-lg-1 col-sm-1 waitlist-course">
    <div class="fa-stack" placement="right" [ngbTooltip]="['Waitlisted']">
      <i class="waitlist-course__warning far fa-circle fa-stack-2x"></i>
      @if (enrollment.Rank == 0) {
        <strong class="fa-stack-1x">W</strong>
      }
      @if (enrollment.Rank > 0) {
        <strong class="fa-stack-1x">{{enrollment.Rank}}</strong>
      }
    </div>
  </div>
  <div class="col-md-4 col-lg-4 col-sm-4 waitlist-course">
    <span class="course">
      @if (!!enrollment.Section.LmsUrl) {
        <a target="_blank" href="{{enrollment.Section.LmsUrl}}">{{ enrollment.Section.Title }}</a>
      }
      @if (!enrollment.Section.LmsUrl) {
        <span>{{ enrollment.Section.Title }}</span>
      }
    </span> ({{ enrollment.Section.CourseCode }}-{{enrollment.Section.SectionNumber}})<br />
    @for (instructor of enrollment.Section.Instructors; track instructor) {
      <div>
        <a class="instructor" href="javascript:void(0)" (click)="openProfile(instructors[instructor])">
          {{ instructors[instructor]?.Name }}
        </a>
      </div>
    }
    <div class="fw-bold">
      {{ enrollment.Section.SeatLabel }}
    </div>
    @for (meeting of enrollment.Section.Meetings; track meeting) {
      <span>
        {{ meeting.Days }} {{ meeting.Start }} - {{ meeting.End }}<br />
        {{ meeting.Building }} {{ meeting.Room }}
      </span>
    }
    @if (!!enrollment.Section.NonStandardMeetingInfo) {
      <span>
        <br />{{enrollment.Section.NonStandardMeetingInfo}}
      </span>
    }

    <div>
      @if (!enrollment.Section.HasClassEnded) {
        <button class="btn-danger btn-sm btn" (click)="drop(enrollment.Section, 'Abandon')" [disabled]="enrollmentService.isDropRunning[enrollment.Section.Id]">
          Abandon {{enrollment.Section.SeatLabel}}
          @if (enrollmentService.isDropRunning[enrollment.Section.Id]) {
            <span class="loader loader-sm loader-light ml-1" role="status" aria-hidden="true"></span>
          }
        </button>
      }
      <br /><br />
    </div>
  </div>

  <div class="col-md-7 col-lg-7 col-sm-7">
    <div class="alert alert-warning">
      <p><strong>POTENTIAL CONFLICTS:</strong> Checked sections automatically drop upon promotion</p>
      @for (section of enrollment.Conflicts; track section) {
        <div class="row col-md-12 col-lg-12 col-sm-12 waitlist-conflicts">
          @for (conflict of section.Conflicts; track conflict) {
            <div class="col-md-12 col-lg-12 col-sm-12">
              <label for="{{section.SectionId}}-{{conflict.SectionId}}">
                @if (isWaitlistRunning[section.SectionId + '-' + conflict.SectionId]) {
                  <span class="span-spinner"><i class="fa fa-spinner fa-spin"></i>  </span>
                }
                @if (!isWaitlistRunning[section.SectionId + '-' + conflict.SectionId]) {
                  <input type="checkbox" class="checkbox-conflict" name="{{section.SectionId}}-{{conflict.SectionId}}" id="{{section.SectionId}}-{{conflict.SectionId}}" value="{{conflict.IsDroppable}}"
                    [checked]="conflict.IsDroppable"
                    (change)="updateWaitlist(section.SectionId, conflict)"
                    [disabled]="isWaitlistRunning[section.SectionId + '-' + conflict.SectionId]">
                  }{{conflict.SectionTitle}}
                </label>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
